export default {
    "1": "语言",
    "2": "你好",
    "3": "立即创建",
    "4": "取消"
}